import React from "react";
import ldlogo from "../assets/Lomnido_logo.png";
import htllogo from "../assets/HTL_Pinkafeld_Logo.png";
 
const About = () => {
    return (
        <div className="container mt-4 whiteBg">
            <h3>About us | Über uns</h3>
            <p className="mt-4">Diplomarbeit `Secure Developer Tool` | 2024 <br></br> Deutsch, Feichtl, Katzbeck, Kogler (Klasse 8YCIF, HTL Pinkafeld) in Kooperation mit Lomnido GmbH</p>
            <img src={htllogo} className="ldlogo" alt="HTL Pinkafeld Logo"></img>
            <img src={ldlogo} className="ldlogo ms-3" alt="Lomnido Logo"></img>
        </div>
    );
};
 
export default About;